import React from "react";
import PropTypes from "prop-types";
import FordLogo from "../../../common/FordLogo";
import { withTranslation } from "react-i18next";
import { IS_FORD_BRAND } from "../../../utils/EmpUtil";
import LincolnLogo from "../../../common/LincolnLogo";
import FordOvalLogo from "../../../imgs/FordOval_Logo-trimmed.png";
import { Box, Grid, Typography } from "@mui/material";

const getBrandingFontFamily = (brand, bold) => {
  if (IS_FORD_BRAND(brand)) {
    return 'var(--body-1-regular-font-family, "Ford F-1")';
  }

  return bold
    ? '"Lincoln Proxima Nova Semibold", Arial, sans-serif'
    : 'var(--body-1-regular-font-family, "Lincoln Proxima Nova")';
};

const getBrandingTextSx = (brand, bold) => ({
  color: "#000",
  fontFamily: getBrandingFontFamily(brand, bold),
  fontSize: "var(--body-1-regular-font-size, 16px)",
  fontStyle: "normal",
  fontWeight: bold ? 600 : "var(--body-1-regular-font-weight, 400)",
  lineHeight: "var(--body-1-regular-line-height, 24px)",
  margin: 0,
});

const formatBranding = (str, showLogoProp, brand, bold) => {
  let text;

  if (showLogoProp) {
    const words = str.split(" ");
    text = (
      <>
        {words[0]} {words[1]} {words[2]}
      </>
    );
  } else {
    text = str;
  }

  return (
    <Typography
      variant={showLogoProp ? "body1" : "body2"}
      component="p"
      sx={getBrandingTextSx(brand, bold)}
    >
      {text}
    </Typography>
  );
};

const EMPBranding = (props) => {
  const isFordBrand = IS_FORD_BRAND(props.brand);

  return (
    <Grid container alignItems="center">
      {props.showLogo && (
        <Box
          sx={{
            marginRight: 2,
            lineHeight: 0,
            width: props.width,
            height: props.height,
            aspectRatio: !isFordBrand ? "153 / 55" : undefined,
          }}
        >
          {isFordBrand && props.ovalFordLogo && (
            <img
              data-testid="ford-logo"
              src={FordOvalLogo}
              alt="FORD"
              width={props.width}
              height={props.height}
            />
          )}
          {isFordBrand && !props.ovalFordLogo && (
            <FordLogo width={props.width} height={props.height} />
          )}
          {!isFordBrand && <LincolnLogo width={props.width} />}
        </Box>
      )}

      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        {formatBranding(
          props.t("GeneralEMP.branding"),
          props.showLogo,
          props.brand,
          props.bold
        )}
      </Box>
    </Grid>
  );
};

EMPBranding.propTypes = {
  bold: PropTypes.bool,
  ovalFordLogo: PropTypes.bool,
  showLogo: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  brand: PropTypes.string,
  t: PropTypes.func.isRequired,
};

EMPBranding.defaultProps = {
  bold: false,
  ovalFordLogo: false,
  showLogo: true,
  width: undefined,
  height: undefined,
  brand: undefined,
};

export default withTranslation("emp")(EMPBranding);
